import { cn } from '@/lib/cn';
import { type HTMLAttributes } from 'react';

type Props = HTMLAttributes<HTMLDivElement>;

export function Card({ className, ...props }: Props) {
  return (
    <div
      className={cn(
        'rounded-[var(--fv-radius-lg)] border border-[var(--fv-border)] bg-[var(--fv-surface)] p-6 shadow-[var(--fv-shadow-sm)]',
        className
      )}
      {...props}
    />
  );
}

export function CardTitle({ className, ...props }: HTMLAttributes<HTMLHeadingElement>) {
  return <h2 className={cn('text-sm font-semibold text-[var(--fv-text)]', className)} {...props} />;
}
